var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPatientAvatarSelected = function SvgPatientAvatarSelected(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "t3zjc93t3a",
    width: "150%",
    height: "150%",
    x: "-25%",
    y: "-25%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.230523383 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#t3zjc93t3a)",
    transform: "translate(-917 -262) translate(700 211) translate(217.271 51)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#4A657B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M32.03 28.739c7.95 0 14.37 5.944 14.37 13.235 0 .675-.55 1.226-1.223 1.226s-1.223-.551-1.223-1.226c0-6.005-5.38-10.845-11.985-10.845-6.603 0-11.923 4.902-11.923 10.845 0 .675-.55 1.226-1.223 1.226s-1.223-.551-1.223-1.226c.061-7.291 6.482-13.235 14.43-13.235zm3.302 4.228c.673 0 1.223.551 1.223 1.225v2.573l2.63.001c.672 0 1.223.551 1.223 1.225 0 .675-.612 1.226-1.284 1.226h-2.569v2.512c-.06.674-.611 1.226-1.223 1.226-.672 0-1.222-.552-1.222-1.226l-.001-2.512H31.48c-.672 0-1.223-.551-1.223-1.226 0-.674.55-1.225 1.223-1.225l2.629-.001v-2.573c0-.674.55-1.225 1.223-1.225zM32.031 14.4c3.852 0 6.97 3.003 6.97 6.74 0 3.738-3.118 6.74-6.97 6.74-3.853 0-6.971-3.002-6.971-6.74 0-3.737 3.118-6.74 6.97-6.74zm0 2.39c-2.507 0-4.586 1.96-4.586 4.35 0 2.39 2.079 4.351 4.586 4.351s4.586-1.96 4.586-4.35c0-2.39-2.08-4.351-4.586-4.351z"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPatientAvatarSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/patient-avatar-selected.73f700d49f8218c1e6d5a0668eac2df0.svg";